//import firebase from "firebase";
import * as firebase from "firebase/app";
import "firebase/messaging";
import axios from "axios";
const url = process.env.REACT_APP_API_TASK;

export const inicializarFirebase = () => {
  firebase.initializeApp({
    messagingSenderId: "933685072828"
  });
};

export const pedirPermissaoParaReceberNotificacoes = async () => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const tokenNotification = await messaging.getToken();
    //let user = localStorage.getItem("user");

    //salvar no bd o uid , user , tokenNotification usando requestPara postDevice
    var objForm = {
      user: localStorage.getItem("user"),
      tokenNotification: tokenNotification,
      uuid: localStorage.getItem("uuid"),
      token: localStorage.getItem("token")
    };

    console.log(objForm);
    axios
      .post(`${url}/postDevice`, { objForm: objForm })
      .then(res => {
        console.log("RESPONSE RECEIVED: ", res);
      })
      .catch(err => {
        console.log("AXIOS ERROR: ", err);
      });

    return tokenNotification;
  } catch (error) {
    console.error(error);
  }
};
